<template>
  <el-dialog
    :visible.sync="isShow"
    width="600px"
    :title="isEdit? '编辑U系列精英集训队/训练营/参赛队' : '添加U系列精英集训队/训练营/参赛队'"
    :close-on-click-modal="false"
    :top="isEdit ? '10vh' : '13vh'"
    custom-class="yioks_alert"
  >
    <el-form
      v-if="!loading"
      ref="centerInfo"
      :model="centerInfo"
      :rules="formRules"
      label-width="140px"
      class="demo-ruleForm">
      <el-row v-if="!isEdit">
        <el-col :span="21">
          <el-form-item label="管理单位" prop="organUuid" >
            <el-select
              v-model="centerInfo.organUuid"
              placeholder="请选择管理单位"
              style="width: 100%;"
              @change="changeOrg">
              <el-option
                v-for="(item,index) in selectOrganList"
                :key="index"
                :value="item.uuid"
                :label="item.organShortName"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-else>
        <el-col :span="21">
          <el-form-item label="管理单位" prop="organUuid" >
            <p >{{centerInfo.organShortName}}</p>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="!isEdit">
        <el-col :span="21">
          <el-form-item label="创建时间" prop="trainCampDate" >
            <el-date-picker
              v-model="centerInfo.trainCampDate"
              type="month"
              style="width: 100%"
              placeholder="请选择创建时间"
              value-format="timestamp"
              :editable="false"
              >
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="21">
          <el-form-item label="类型" prop="trainCampType">
            <el-select
              v-model="centerInfo.trainCampType"
              placeholder="请选择类型"
              style="width: 100%;">
              <el-option
                v-for="(item,index) in trainCampTypeList"
                :key="index"
                :value="item.value"
                :label="item.label"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <!--<el-row>-->
        <!--<el-col :span="21">-->
          <!--<el-form-item label="全称" prop="youthName">-->
            <!--<el-select-->
              <!--v-model="centerInfo.youthName"-->
              <!--placeholder="请选择全称"-->
              <!--:disabled="isEdit"-->
              <!--style="width: 100%;"-->
              <!--@change="changeYouthName">-->
              <!--<el-option-->
                <!--v-for="(item,index) in youthNameList"-->
                <!--:key="index"-->
                <!--:value="item.youthName"-->
                <!--:label="item.youthName"-->
              <!--&gt;-->
              <!--</el-option>-->
            <!--</el-select>-->
          <!--</el-form-item>-->
        <!--</el-col>-->
      <!--</el-row>-->
      <!--<el-row>-->
        <!--<el-col :span="21">-->
          <!--<el-form-item label="简称" prop="youthShortName">-->
            <!--<el-select-->
              <!--v-model="centerInfo.youthShortName"-->
              <!--placeholder="请选择简称"-->
              <!--disabled-->
              <!--style="width: 100%;">-->
              <!--<el-option-->
                <!--v-for="(item,index) in youthNameList"-->
                <!--:key="index"-->
                <!--:value="item.youthShortName"-->
                <!--:label="item.youthShortName"-->
              <!--&gt;-->
              <!--</el-option>-->
            <!--</el-select>-->
          <!--</el-form-item>-->
        <!--</el-col>-->
      <!--</el-row>-->
      <el-row>
        <el-col :span="21">
          <el-form-item label="全称" prop="youthName">
            <el-input v-model.trim="centerInfo.youthName" placeholder="请输入全称" :disabled="isEdit" maxlength="50" show-word-limit></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="21">
          <el-form-item label="简称" prop="youthShortName">
            <el-input v-model.trim="centerInfo.youthShortName" placeholder="请输入简称" :disabled="isEdit" maxlength="50" show-word-limit></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row class="provinceTrainCamp" >
        <!--<div class="label"></div>-->
        <!-- <el-col :span="13">
          <el-form-item label="精英集训队所在地"  prop="provinceCode">
            <el-select v-model="centerInfo.provinceCode" placeholder="请选择省" @change="changeProvince">
              <el-option
                v-for="item in regions"
                :key="item.code"
                :value="item.code"
                :label="item.name"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col> -->
        <el-col :span="13" >
          <el-form-item  label="精英集训队所属区域" prop="cityCode">
            <el-select
              v-model="centerInfo.cityCode"
              placeholder="请选择市"
              @change="changeCityForAddTrainCamp" >
              <el-option
                v-for="item in cityList"
                :key="item.code"
                :value="item.code"
                :label="item.name"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="7" :offset="1">
          <el-form-item label="" label-width="0" prop="countyCode">
            <el-select
              v-model="centerInfo.countyCode"
              placeholder="请选择区"
              @change="changeCountyForTrainCamp" >
              <el-option
                v-for="item in sh_county_list"
                :key="item.code"
                :value="item.code"
                :label="item.name"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="isEdit">
        <el-col :span="21">
          <el-form-item label="状态" prop="status">
            <el-select v-model.trim="centerInfo.status" style="width: 100%">
              <el-option
                v-for="(item, index) in centerStatusList"
                :key="index"
                :label="item.name"
                :value="item.status"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="isEdit">
        <el-col :span="21">
          <el-form-item label="上传logo">
            <UploadImg :imgUrl.sync='centerInfo.banner'  :errImg='img' avatarUrl.sync="" />
            <div>支持jpg,jpeg,bmp,gif,png格式上传</div>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div v-if="!loading" class="dialog_btn_wrap">
      <el-button
        type="primary"
        style="margin-right:20px"
        :loading="addbtnLoading"
        @click="addCenterOrg"
      >确定</el-button>
      <el-button type="danger" @click="isShow= false">取消</el-button>
    </div>
    <yioks-loading v-if="loading" style="height: 500px" />
  </el-dialog>
</template>

<script>
import storage from '@/utils/storage'
import rulesMixin from '@/utils/formRules/trainCamp'
import regions from '@/utils/regions'
// import auth from '@/api/auth'
import { centerStatusList,trainCampTypeList } from '@/utils/yioks_data'
import trainCamp from '@/api/trainCamp'
import trainCampImg from '@/assets/images/common/trainCamp.png'

export default {
  name: 'index',
  components: {
    'UploadImg': () => import('@/components/UploadImg')
  },
  mixins: [rulesMixin],
  props: {
    addCenter: {
      type: Boolean,
      required: true
    },
    organList: {
      type: Array,
      required: false
    },
    isEdit: {
      type: Boolean,
      required: false
    },
    centerUuid: {
      type: String,
      required: false
    }
  },
  data () {
    return {
      img: trainCampImg,
      regions,
      youthNameList: [],
      cityList: [],
      loading: false,
      addbtnLoading: false,
      selectOrganList: [],
      centerStatusList,
      trainCampTypeList,
      centerInfo: {
        youthName: '',
        youthShortName: '',
        organUuid: '',
        organShortName: '',
        trainCampDate: '',
        trainCampType: '',
        provinceCode: '',
        provinceName: '',
        cityCode: '',
        cityName: '',
        countyCode: '',
        countyName: '',
        status: '',
        banner: ''
      },
      userRole: storage.get('userInfo').userRole,
      uuid: storage.get('userInfo').uuid
    }
  },
  computed: {
    isShow: {
      get () {
        return this.addCenter
      },
      set (val) {
        this.$emit('update:addCenter', val)
      }
    },


    sh_county_list() {
      let arr = [];
      regions.forEach(item => {
        if(item.code === '31') {
          const { county, name } = item.city[0];
          arr = county
        }
      })
      return arr
    },
  },
  created () {
    if (this.centerUuid) {
      this.getCenterInfo()
    }
    if (this.organList && this.organList.length > 0) {
      this.selectOrganList = this.organList
      if (this.selectOrganList.length === 1) {
        this.$set(this.centerInfo, 'organUuid', this.selectOrganList[0].uuid)
        this.$set(this.centerInfo, 'organShortName', this.selectOrganList[0].organShortName)
      }
    }
    this.$set(this.centerInfo, 'provinceCode', '31')
    this.changeProvince();  // 已设置默认上海
  },
  methods: {
    getCenterInfo () {
      this.loading = true
      trainCamp.getCenterInfo(this.centerUuid).then((res) => {
        const { countyCode, countyName, cityName, cityCode, provinceName, provinceCode, youthName, youthShortName, organUuid, organShortName, status, id, banner,trainCampType } = res.youth
        this.centerInfo = {
          cityName,
          id,
          countyCode: Number(countyCode) === 0 ? '' : String(countyCode),
          countyName,
          cityCode: Number(cityCode) === 0 ? '' : String(cityCode),
          provinceName,
          provinceCode: Number(provinceCode) === 0 ? '' : String(provinceCode),
          youthShortName,
          trainCampType,
          youthName,
          organUuid,
          organShortName,
          status,
          banner: banner || ''
        }
        this.setCityList()
        this.loading = false
      })
    },
    changeOrg () {
      this.centerInfo.organShortName = this.selectOrganList.find(item => {
        return item.uuid === this.centerInfo.organUuid
      }).organShortName
      this.changeDate()
    },
//    changeDate () {
//      if (this.centerInfo.trainCampDate && this.centerInfo.organShortName) {
//        const youthNameList = []
//        let year = new Date(this.centerInfo.trainCampDate).getFullYear()
//        let month = new Date(this.centerInfo.trainCampDate).getMonth() + 1
//        youthNameList.push({ youthName: year + '年' + this.centerInfo.organShortName + 'U系列精英集训队', id: 1, youthShortName: year + '年' + 'U系列集训队' })
//        youthNameList.push({ youthName: year + '年' + month + '月' + this.centerInfo.organShortName + '精英训练营', id: 2, youthShortName: year + '年' + month + '月' + '精英训练营' })
//        this.youthNameList = youthNameList
//      }
//      this.centerInfo.youthName = ''
//      this.centerInfo.youthShortName = ''
//    },
    changeYouthName () {
      this.centerInfo.youthShortName = this.youthNameList.find(item => {
        return item.youthName === this.centerInfo.youthName
      }).youthShortName
    },
    changeCityForAddTrainCamp () {
      this.centerInfo.cityName = this.cityList.find(item => {
        return item.code === this.centerInfo.cityCode
      }).name
    },
    changeCountyForTrainCamp() {
      this.centerInfo.countyName = this.sh_county_list.find(item => {
        return item.code === this.centerInfo.countyCode
      }).name || ''
    },
    changeProvince () {
      this.regions.forEach(item => {
        if (item.code === this.centerInfo.provinceCode) {
          this.cityList = item.city
          this.$set(this.centerInfo, 'cityCode', this.cityList[0].code)
          this.$set(this.centerInfo, 'cityName', this.cityList[0].name)
          this.centerInfo.provinceName = item.name
        }
      })
    },
    getOrgList () {
      let request, data
      if (this.userRole === 'system' || this.userRole === 'admin') {
        request = trainCamp.getListBySystem
        data = ''
      } else {
        request = trainCamp.getListByOrg
        data = this.uuid
      }
      request(data).then(res => {
        this.selectOrganList = res
      })
    },
    setCityList () {
      this.regions.forEach(item => {
        if (item.code === this.centerInfo.provinceCode) {
          this.cityList = item.city
        }
      })
    },
    addCenterOrg () {
      this.$refs['centerInfo'].validate(async valid => {
        if (valid) {
          this.addbtnLoading = true
          let requestName = trainCamp.addCenter
          let requestData = {
            youthForm: {
              provinceCode: this.centerInfo.provinceCode,
              provinceName: this.centerInfo.provinceName,
              cityCode: this.centerInfo.cityCode,
              cityName: this.centerInfo.cityName,
              countyCode: this.centerInfo.countyCode,
              countyName: this.centerInfo.countyName,
              organUuid: this.centerInfo.organUuid,
              organShortName: this.centerInfo.organShortName,
              youthName: this.centerInfo.youthName,
              youthShortName: this.centerInfo.youthShortName,
              trainCampType: this.centerInfo.trainCampType,
              banner: this.centerInfo.banner
            }
          }
          if (this.isEdit) {
            requestName = trainCamp.updateCenter
            requestData.youthForm.status = this.centerInfo.status
            requestData.youthForm.id = this.centerInfo.id
          }
          requestName(requestData).then(res => {
            this.addbtnLoading = false
            if (res.code) {
              this.$message.error(res.msg)
            } else {
              this.$emit('hideDialog', false)
            }
          }).catch(err => {
            this.addbtnLoading = false
            console.error(err)
          })
        }
      })
    }
  }
}
</script>

<style scoped lang="stylus">
  .tip
    margin-top 10px
    color red
    width 100%
    text-align center
    word-break break-word
</style>
<style lang="stylus">
  .provinceTrainCamp
    display flex
    .label
      width: 140px;
      height 40px
      line-height 40px
      text-align center
</style>
